import { memo, useEffect, useState } from "react";
import {
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Table,
  TableBody,
  Chip,
  Typography,
  TextField,
  Autocomplete,
  FormControl,
  Select,
  MenuItem,
  TablePagination,
} from "@mui/material";
import StatusDialog from "./StatusDialog";
import { enqueueSnackbar } from "notistack";
import { chargebackReset } from "../../../../API/backendAPI";
import { useOutletContext, useRouteLoaderData } from "react-router-dom";
import {
  formatAmount,
  Loader,
} from "../../../../HelperFunctions/HelperFunctions";
import { userSecurity } from "../../../../API/nimbleAPI";
import SecurityLockDialog from "../../.././Reconciliation/Tabs/DSCards/SecurityLockDialog/SecurityLockDialog";
import dayjs from "dayjs";
import { useRef } from "react";
import CustomPagination from "../../../../HelperFunctions/CustomPagination";

const PendingTable = ({
  initialRows,
  onUpdateTabValues,
  selectedCorpState,
}) => {

  const { setRestartSSE } = useOutletContext();
  const { userId,journal } = useRouteLoaderData("reconciliation");
  const [openSecurityDialog, setOpenSecurityDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [chargeBacksReversedDate, setchargeBacksReversedDate] = useState();

  const [statusDialog, setStatusDialog] = useState({
    open: false,
    option: null,
    data: null,
  });
  const [rows, setRows] = useState(initialRows || []);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(40);
  const totalPages = Math.ceil(rows.length / rowsPerPage);

  const paginatedRows = rows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );
  const tableContainerRef = useRef(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    setRows(initialRows || []);
  }, [initialRows]);

  const columns = [
    { name: "Case Number", dataKey: "case_number", width: 100 },
    { name: "Chargeback Date", dataKey: "charge_back_date", width: 130 },
    { name: "Transaction Date", dataKey: "transaction_date", width: 130 },
    { name: "Dispute Date", dataKey: "dispute_date", width: 130 },
    { name: "Cardholder Number", dataKey: "cardholder_name", width: 150 },
    { name: "Reason for Chargeback", dataKey: "reason", width: 180 },
    { name: "Amount", dataKey: "amount", width: 100 },
    // { name: 'Days left to respond', dataKey: 'days_left', width: 100 },
    { name: "Reversal Status", dataKey: "reversal_status", width: 100 },
    { name: "Status", dataKey: "status", width: 150 },
  ];

  const statusList = [
    {
      statusName: "Responded",
      statusValue: "responded",
    },
    {
      statusName: "Not Responded",
      statusValue: "not_responded",
    },
    {
      statusName: "Reversed",
      statusValue: "reversed",
    },
    {
      statusName: "Irreversible",
      statusValue: "irreversible",
    },
  ];

  const changeStatus = async (data) => {
    try {
      const payload = {
        id: data._id,
        user_id: userId,
      };
      const statusUpdate = await chargebackReset(payload);

      setRows((prev) => prev.filter((row) => row._id !== statusUpdate._id));
      onUpdateTabValues();
      setRestartSSE((prev) => !prev);
      enqueueSnackbar(`successfully updated to Not Responded`, {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar("Error while changing the status", { variant: "error" });
    }
  };
 

  const ValueCell = memo(({ value }) => {
    const displayValue = value !== null ? value : "-";
    return <span title={displayValue}>{displayValue}</span>;
  });

  const StatusSelect = ({ defaultValue, data }) => {
    const [status, setStatus] = useState(
      statusList.find((item) => item.statusValue === defaultValue) || null,
    );

    return (
      <FormControl variant="outlined" size="small" sx={{ minWidth: "150px" }}>
        <Select
          value={status?.statusValue || ""}
          onChange={async (e) => {
            const val = statusList.find(
              (item) => item.statusValue === e.target.value,
            );
            if (
              val?.statusValue === "reversed" ||
              val?.statusValue === "irreversible" ||
              val?.statusValue === "responded"
            ) {
               if (val.statusValue === "reversed") {
       setchargeBacksReversedDate(data.charge_back_date)
    }
              if (val.statusValue === "reversed") {
                   if (journal?.Create !== true) {
                      enqueueSnackbar(
                        "The user doesn't have the journal entry approval privileges to post the reversal entry",
                        {
                          variant: "error",
                        },
                      );
                      return;
                    }
                try {
                  setLoading(true);
                  const payload = {
                    corpID: selectedCorpState,
                    booksDate: dayjs()
                      .utc()
                      .startOf("day")
                      .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
                    type: 20,
                  };
                

                  const security = await userSecurity(payload);
                  setLoading(false);

                  if (security) {
                    setOpenSecurityDialog(true);
                    return;
                  }
                } catch (err) {
                  setLoading(false);
                  enqueueSnackbar("Security check failed", {
                    variant: "error",
                  });
                  return;
                }
              }
              setStatus(val);
              setStatusDialog({ open: true, option: val, data: data });
            } else {
              // setStatus(val);
              const confirmChange = window.confirm(
                // `Are you sure you want to change status to "${val?.statusName}"?`
                "Selected chargeback is recoded as responded, changing to not responded will erase the responded date, Do you want to continue?",
              );

              if (confirmChange) {
                changeStatus(data);
              }
            }
          }}
          displayEmpty
          sx={{
            height: "25px",
            fontSize: "12px",
            "& .MuiSelect-select": {
              padding: "0px 8px",
              lineHeight: "25px",
            },
          }}
        >
          {statusList.map((option) => (
            <MenuItem
              key={option.statusValue}
              value={option.statusValue}
              sx={{ fontSize: "12px", padding: "2px 8px" }}
              disabled={
                option.statusValue === "reversed" && data.amount > 0
              }
            >
              {option.statusName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const RenderChip = ({ value, type }) => (
    <Chip
      sx={{
        borderRadius: 1,
        backgroundColor:
          type === "Days left to respond" ? "#f9dadd" : "#fdecd5",
        fontSize: "11px",
        fontWeight: 600,
        color: type === "Days left to respond" ? "#da0621" : "#f59c28",
        px: 1,
        "& .MuiChip-icon": {
          color: type === "Days left to respond" ? "#da0621" : "#f59c28",
          fontSize: "13px",
        },
      }}
      label={value ? value : "-"}
      size="small"
    />
  );

  const handleStatusUpdate = ({ _id, updated_to }) => {
    setRows((prev) => prev.filter((row) => row._id !== _id));
    onUpdateTabValues();
    setRestartSSE((prev) => !prev);
    setStatusDialog((prev) => ({ ...prev, open: false }));
    enqueueSnackbar(`successfully updated to ${updated_to}`, {
      variant: "success",
    });
  };

  return (
    <>
      <TableContainer
        ref={tableContainerRef}
        sx={{ overflow: "auto", height: "100%" }}
      >
        <Table stickyHeader sx={{ width: "100%" }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#d7d7d7" }}>
              {columns.map((col, idx) => (
                <TableCell
                  key={idx}
                  style={{
                    backgroundColor: "#d7d7d7",
                    // borderRight: "1px solid white",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontSize: 13,
                    maxWidth: col.width,
                  }}
                >
                  <span title={col.name}> {col.name} </span>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={columns.length + 4}
                  align="center"
                  sx={{ fontSize: 14, color: "#999" }}
                >
                  No data available
                </TableCell>
              </TableRow>
            ) : (
              paginatedRows.map((row, rowIndex) => (
                <TableRow key={row.schedule_id} hover>
                  {columns.map((col, idx) => (
                    <TableCell
                      key={idx}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: 12,
                        fontWeight: 500,
                        color: "#626262",
                        // borderRight: "1px solid #f2f2f2",
                        maxWidth: col.width,
                      }}
                    >
                      {col.name == "Days left to respond" ||
                        col.name == "Reversal Status" ? (
                        <RenderChip value={row[col.dataKey]} type={col.name} />
                      ) : col.name === "Status" ? (
                        <StatusSelect
                          defaultValue={row[col.dataKey]}
                          data={row}
                        />
                      ) : col.name === "Amount" ? (
                        <Typography fontWeight={500} fontSize={12}>
                          $ {formatAmount(row[col.dataKey])}
                        </Typography>
                      ) : (
                        <ValueCell value={row[col.dataKey]} />
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination
        page={page}
        totalPages={totalPages}
        onPageChange={setPage}
        scrollRef={tableContainerRef}
      />

      {statusDialog.open && (
        <StatusDialog
        // data={data}
          open={statusDialog}
          onClose={() => setStatusDialog((prev) => ({ ...prev, open: false }))}
          onStatusUpdate={handleStatusUpdate}
          chargeBacksReversedDate={chargeBacksReversedDate}
        />
      )}
      <SecurityLockDialog
        open={openSecurityDialog}
        onClose={() => setOpenSecurityDialog(false)}
        onSuccess={() => {
          setOpenSecurityDialog(false);
        }}
      />

      {loading && <Loader loading={loading} />}
    </>
  );
};
export default PendingTable;
